export const SET_NAV_LINK = 'SET_NAV_LINK'
export const UNSET_NAV_LINK = 'UNSET_NAV_LINK'
export const SUPPRESS_NAV = 'SUPPRESS_NAV'
export const UN_SUPPRESS_NAV = 'UN_SUPPRESS_NAV'

export const NAV_LINKS = {
  noaccess: '/noaccess',
  login: '/login',
  dashboard: '/dashboard',
  approvals: '/approvals',
  settings: '/settings',
  refunds: '/refunds',
  orders: '/orders',
  reshipment: '/orders/reshipment',
  generateapid: '/apidgeneration',
  studentLocation: '/studentlocation',
  // settings: '/settings',
}

export const ROUTES = [
  { path: NAV_LINKS.dashboard, component: 'DashboardPage', title: 'Dashboard' },
  { path: NAV_LINKS.orders, component: 'OrdersPage', title: 'Orders' },
  { path: NAV_LINKS.reshipment, component: 'ReshipmentPage', title: 'Reshipment' },
  { path: NAV_LINKS.approvals, component: 'ApprovalRequestsPage', title: 'Approval Requests' },
  { path: NAV_LINKS.refunds, component: 'RefundExamsPage', title: 'Refund Exams' },
  { path: NAV_LINKS.generateapid, component: 'GenerateAPIDPage', title: 'AP ID Generation' },
  {
    path: NAV_LINKS.studentLocation,
    component: 'UpdateStudentLocationPage',
    title: 'Student Location',
  },
  // { path: NAV_LINKS.settings, component: 'SettingsPage', title: 'Settings' },
]
